import ExcelJS from 'exceljs'

const BORDA = {
  top: { style: 'thin' },
  left: { style: 'thin' },
  bottom: { style: 'thin' },
  right: { style: 'thin' },
}

export async function gerarExcelTotalProdutos({ datas_previstas, empresas }) {
  if (!empresas || empresas.length === 0) {
    throw new Error('Nenhum produto encontrado nos veículos selecionados')
  }

  const workbook = new ExcelJS.Workbook()
  const sheet = workbook.addWorksheet('Total de Produtos', {
    views: [{ state: 'frozen', ySplit: 1 }],
  })

  sheet.columns = [
    { header: 'Código do Produto', width: 18 },
    { header: 'Descrição do Produto', width: 55 },
    { header: 'Qte Total Faturada', width: 18 },
    { header: 'Estoque Total Atual', width: 18 },
    { header: 'Data Prevista da Rota', width: 22 },
    { header: 'Empresa', width: 30 },
  ]

  const cabecalho = sheet.getRow(1)
  cabecalho.height = 30
  cabecalho.eachCell(cell => {
    cell.font = { bold: true }
    cell.border = BORDA
    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true }
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE0E0E0' } }
  })

  empresas.forEach(empresa => {
    empresa.produtos.forEach(produto => {
      const row = sheet.addRow([
        produto.produto_codigo,
        produto.produto_nome,
        produto.qte_faturada,
        produto.estoque_atual,
        toDataExcel(produto.datas_previstas),
        empresa.company_name,
      ])

      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.border = BORDA
        if (colNumber !== 2 && colNumber !== 6) cell.alignment = { horizontal: 'center' }
      })
      row.getCell(5).numFmt = 'dd/mm/yyyy'
      if (produto.estoque_insuficiente) {
        row.getCell(4).font = { bold: true, color: { argb: 'FFC62828' } }
      }
    })
  })

  sheet.autoFilter = { from: 'A1', to: 'F1' }

  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const datas = datas_previstas.split(', ')
  const periodo = datas.length > 1 ? `${datas[0]}_a_${datas[datas.length - 1]}` : datas[0]
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `total_produtos_${periodo.replace(/\//g, '-')}.xlsx`
  a.click()
  window.URL.revokeObjectURL(url)
}

function toDataExcel(datas) {
  if (datas.includes(',')) return datas
  const [dia, mes, ano] = datas.split('/').map(Number)
  return new Date(Date.UTC(ano, mes - 1, dia))
}
